import { Box, IconButton } from "@mui/material";
import React, { FC } from "react";
import { Link, Outlet, useNavigate } from "react-router-dom";
import { ROUTE_PATHS } from "../routes";
import youCaterLogo from "../assets/images/youCaterLogo.png";
import CrossIconSvg from "../assets/svg-fc/CrossIconSvg";
import palette from "../theme/palette";
import IsMobile from "../hooks/isMobile";
import "./AuthLayout.scss";

interface iAuthLayoutProps {
	onClose?: () => void;
}

const AuthLayout: FC<iAuthLayoutProps> = ({ onClose }) => {
	const navigate = useNavigate();
	const isMobile = IsMobile();

	return (
		<Box className="auth-layout">
			<Box
				component="header"
				className={`auth-layout-header${isMobile ? " auth-layout-header--mobile" : ""}`}
			>
				<Link to={ROUTE_PATHS.LOGIN} className="auth-layout-logo">
					<picture>
						<img src={youCaterLogo} alt="logo" />
					</picture>
				</Link>
				<IconButton
					aria-label="Close and go to login"
					onClick={onClose ?? (() => navigate(ROUTE_PATHS.LOGIN))}
					className="auth-layout-close"
					size="medium"
				>
					<CrossIconSvg size={isMobile ? "12" : "14"} color={palette.secondary.main} />
				</IconButton>
			</Box>
			<Box component="main" className="auth-layout-main">
				<Outlet />
			</Box>
		</Box>
	);
};

export default AuthLayout;
